import React from "react";
import styles from "./RuleEntityAction.module.scss";

interface Props {
    value: string;
}

export const RuleAccountNameAction: React.FC<Props> = ({ value }) => (
    <div>
        Assign to{" "}
        <div className={styles.entityLead}>
            <strong>{value}</strong>
        </div>
        .
    </div>
);
